var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{attrs:{"text":_vm.$t('adgroup_placement_select_info'),"link-text":_vm.$t('adformat_learn_more'),"link-url":"/help/article?aid=6669234451085524998","width":"100%","type":"warning"}})}
var staticRenderFns = []

export { render, staticRenderFns }